import { buildCdnPath } from "./buildCdnPath";

export function buildCountryFlagPath(countryCode: string) {
  return buildCdnPath(["country", countryCode.toLowerCase()]);
}
